var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0158 8.068L8.64381 5.62L8.78781 7.168H5.57181V8.968H8.78781L8.64381 10.528L12.0158 8.068Z",
    fill: "#537089"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 15,
    height: 15,
    rx: 3.5,
    stroke: "#537089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyRight);
export default __webpack_public_path__ + "static/media/key-right.c849be60440c07512c2268060714dc49.svg";
export { ForwardRef as ReactComponent };